import { MouseEvent } from 'react';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import ArrowIcon from '../../icons/ArrowIcon';

const BlueCircleButton = styled(Button)`
  background: #0b6cff;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const SendButton = ({
  onClick,
}: {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <BlueCircleButton type="button" onClick={onClick} aria-label="Send message">
      <ArrowIcon direction="up" width="22px" height="22px" />
    </BlueCircleButton>
  );
};

export default SendButton;
